<template>
  <section :class="$style.wrapper">
    <div :class="$style.close" @click="onClose">
      <IconClose />
    </div>
    <div :class="$style.header">
      <div :class="$style.headerTitle">{{ $t("Pay with") }}</div>
    </div>
    <TabPaneItem
      v-for="(item, index) in getTabPanel"
      :key="index"
      :itemData="item"
      :isEnoughBalance="isEnoughBalance"
      @change:paneItem="onSelectPayment"
    >
    </TabPaneItem>
  </section>
</template>

<script>
import TabPaneItem from "@/components/tradePaymentList/TabPaneItem.vue";
import IconClose from "@/assets/img/common/icon-close.svg?inline";

export default {
  name: "Modal.SelectPayments",
  props: {},
  data() {
    return {};
  },
  computed: {
    getTabPanel() {
      return this.$attrs.tabPanle;
    },
    isEnoughBalance() {
      return this.$attrs.isEnoughBalance;
    }
  },
  components: {
    TabPaneItem,
    IconClose
  },
  methods: {
    onSelectPayment(data) {
      this.$emit("change:paneItem", data);
    },
    onClose() {
      this.$emit("close");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style module lang="scss">
@import "~rfs/scss";
.wrapper {
  @include rfs(40px 14px, padding);

  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--legend-panel-bg);
  max-width: 347px;
  margin: 0 auto;
  border-radius: 10px;
  position: relative;

  .close {
    position: absolute;
    right: 16px;
    top: 16px;
    color: var(--silver);
    cursor: pointer;

    &:hover {
      color: var(--primary);
    }
    svg {
      width: rfs-value(16px);
      height: rfs-value(16px);
    }
  }

  .header {
    @include rfs(14px, margin-bottom);
    width: 100%;
    .headerTitle {
      @include rfs(16px);

      text-align: left;
      font-weight: 500;
      color: var(--primary);
    }
  }
}
</style>
